export const MAX_INVOICE_NAME_LENGTH = 200;
export const MAX_INVOICE_NAME_ALIASES = 10;
